/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TripMode {
  Air = 0,
  Bicycle = 1,
  Bus = 2,
  Cableway = 3,
  Water = 4,
  Funicular = 5,
  Lift = 6,
  Rail = 7,
  Metro = 8,
  Taxi = 9,
  Tram = 10,
  Trolleybus = 11,
  Monorail = 12,
  Coach = 13,
  Foot = 14,
  Car = 15,
  Scooter = 16,
}
